var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 0C0.745443 0 0 0.745443 0 1.66667C0 2.58789 0.745443 3.33333 1.66667 3.33333C2.58789 3.33333 3.33333 2.58789 3.33333 1.66667C3.33333 0.745443 2.58789 0 1.66667 0ZM8.33333 0C7.41211 0 6.66667 0.745443 6.66667 1.66667C6.66667 2.58789 7.41211 3.33333 8.33333 3.33333C9.25456 3.33333 10 2.58789 10 1.66667C10 0.745443 9.25456 0 8.33333 0ZM1.66667 6.66667C0.745443 6.66667 0 7.41211 0 8.33333C0 9.25456 0.745443 10 1.66667 10C2.58789 10 3.33333 9.25456 3.33333 8.33333C3.33333 7.41211 2.58789 6.66667 1.66667 6.66667ZM8.33333 6.66667C7.41211 6.66667 6.66667 7.41211 6.66667 8.33333C6.66667 9.25456 7.41211 10 8.33333 10C9.25456 10 10 9.25456 10 8.33333C10 7.41211 9.25456 6.66667 8.33333 6.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/SortIcon.0d56b84303a625cff86ad99511e3aa22.svg";
export { ForwardRef as ReactComponent };